"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOnboardingStatus = void 0;
var date_fns_1 = require("date-fns");
var getOnboardingStatus = function (_a) {
    var supplyStartDate = _a.supplyStartDate, omrWindowStatus = _a.omrWindowStatus, hasSubmittedOmrs = _a.hasSubmittedOmrs;
    return {
        switchRequest: 'done',
        switchingInitiated: omrWindowStatus.isBeforeWindow ? 'in-progress' : 'done',
        OMRRequested: hasSubmittedOmrs
            ? 'done'
            : omrWindowStatus.isDuringWindow
                ? 'in-progress'
                : 'coming-up',
        onSupply: (0, date_fns_1.isAfter)(new Date(), supplyStartDate) ||
            (hasSubmittedOmrs && omrWindowStatus.isAfterWindow)
            ? 'done'
            : 'coming-up',
    };
};
exports.getOnboardingStatus = getOnboardingStatus;
